var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line import/no-extraneous-dependencies
import { Transition } from '@headlessui/react';
import clsx from 'clsx';
// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react';
// eslint-disable-next-line react/display-name
var withLoading = function (Component, Skeleton, options) {
    var WithLoading = /** @class */ (function (_super) {
        __extends(WithLoading, _super);
        function WithLoading() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        WithLoading.prototype.render = function () {
            return (_jsxs("div", { className: clsx('relative', options === null || options === void 0 ? void 0 : options.wrapperClassName), children: [_jsx(Transition, { className: clsx(options === null || options === void 0 ? void 0 : options.componentClassName), enter: "transition-opacity duration-300 delay-300", enterFrom: "opacity-0", enterTo: "opacity-100", show: !this.props.isLoading, children: _jsx(Component, __assign({}, this.props)) }), _jsx(Transition, { className: clsx(options === null || options === void 0 ? void 0 : options.skeletonClassName), enter: "transition-opacity", leave: "transition-opacity absolute left-0 top-0 w-full duration-300", leaveFrom: "opacity-100", leaveTo: "opacity-0", show: this.props.isLoading, children: _jsx(Skeleton, __assign({}, this.props)) })] }));
        };
        return WithLoading;
    }(React.Component));
    return WithLoading;
};
export { withLoading as default };
